import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, tap } from '@proman/rxjs-common';
import { pos2TableAction } from '@pos-shop-shared/store';
import { Pos2ActionService } from '../shared/pos2-action.service';
@Injectable()
export class Pos2Effects {

    handleTableActions$ = createEffect(() => this.actions$
            .pipe(
                ofType(pos2TableAction),
                map((action) => action.payload),
                tap((action) => {
                    this.Pos2ActionService.tableAction$.next(action);

                })
            ),
        { dispatch: false }
    )

    constructor(
        private store: Store,
        private actions$: Actions,
        private Pos2ActionService: Pos2ActionService,
    ) {

    }

}
